export default "__VITE_ASSET__ZXtF4S3F__"